// File: src/components/Charts/DeviceChart.jsx
import React from 'react';
import 'chart.js/auto';
import { Pie } from 'react-chartjs-2';

const BRAND = ['#6A0DAD', '#00A8A9', '#B475E1', '#4DDBDB', '#2B054A', '#004E4F'];

export default function DeviceChart({
  deviceCounts = {},
  height = '100%',
  showLegend = true,
  padding = { top: 20, right: 20, bottom: 20, left: 20 },
  radiusPct = 0.70,     // 👈 new: 0.85 = 85% of available size
  donut = false,        // optional: make it a donut
  cutoutPct = 0.55,     // donut inner radius when donut=true
}) {
  const labels = Object.keys(deviceCounts);
  const values = Object.values(deviceCounts);

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: labels.map((_, i) => BRAND[i % BRAND.length]),
        borderColor: labels.map((_, i) => BRAND[i % BRAND.length]),
        borderWidth: 1,
        hoverOffset: 6,
        // dataset-level radius (works in Chart.js v3/v4)
        radius: `${Math.round(radiusPct * 100)}%`,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding },
    // chart-level radius (also works; dataset takes precedence if both set)
    radius: `${Math.round(radiusPct * 100)}%`,
    cutout: donut ? `${Math.round(cutoutPct * 100)}%` : undefined,
    plugins: {
      title: { display: false },
      legend: { display: showLegend, position: 'bottom', labels: { padding: 12 } },
      tooltip: {
        callbacks: { label: (ctx) => `${ctx.label}: ${ctx.parsed} sessions` },
      },
    },
    animation: { duration: 400 },
  };

  const containerHeight = typeof height === 'number' ? `${height}px` : height;

  return (
    <div
      style={{
        position: 'relative',
        height: containerHeight,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {labels.length ? <Pie data={data} options={options} /> : null}
    </div>
  );
}
